import React, { useEffect, useState } from "react";
import VillaItem from "../VillaItem";
import Skeleton from "react-loading-skeleton";
import Banner from "../ProductCategory/Banner";
import TopSearchBar from "../ProductCategory/TopSearchBar";
import FilterSummary from "../ProductCategory/FilterSummary";
import { useRouter } from "next/router";
import { FilterApi } from "../api";
import { toast } from "react-toastify";
import Content from "../ProductCategory/Content";
import Pagination from "../ProductCategory/Pagination";
import ShortTerms from "../Index/ShortTerms";
import * as c from "../../scripts/criteo";
import { useTranslation } from "../../context/TranslationContext";
import useWindowSize from "../windowDimension";
import KiralaGelBanner from "../KiralaGelBanner";
import SkeletonView from "../ListVilla/SkeletonView";
import isMobile from "is-mobile";

export function getCookie(name) {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}
const ProductCategory = ({ ssr, isAppWebView, deviceType }) => {
  const { searchResultSlug } = useTranslation();
  const router = useRouter();
  const { width } = useWindowSize();
  const isPhone = isMobile();

  const page = ssr.result;
  const currentRoutingTypeId = ssr.RoutingTypeId;

  const [currentPage, setcurrentPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [totalRecord, setTotalRecord] = useState(0);

  const [data, setData] = useState(false);
  const [isLoading, setIsloading] = useState(true);
  const [error, setError] = useState();

  useEffect(() => {
    setIsloading(true);
    setcurrentPage(parseInt(router.query.s ? router.query.s : 1));

    FilterApi({
      page: router.query.s ? router.query.s : 1,
      CurrentRoutingTypeId: currentRoutingTypeId,
      EntityId: ssr.EntityId,
      searchdate1: router.query.start || "",
      searchdate2: router.query.end || "",
      bolge: router.query.bolge || "",
      tip: router.query.tip || "",
      yetiskin: router.query.yetiskin || 1,
      cocuk: router.query.cocuk || 0,
      order_by: router.query.order_by || 0,
      ay: router.query.ay || 0,
      gece: router.query.gece || 0,
      min: router.query.min || "",
      max: router.query.max || "",
      showall: ssr.result.ShowTopSearchBar == "0" ? 1 : 0,
      ids: router.query.ids || "",
      search: router.query.search || "",
      customList: page?.CustomList?.PageId || 0,
      disableCalendarRules: router?.query?.disableCalendarRules || 0,
      userLink: getCookie("user-link") || 0,
    })
      .then((response) => {
        if (response.data.error) {
          setError(response.data.error);
          setData(false);
        } else {
          setData(response.data.result);
          setError(false);
        }
        setTotalRecord(response.data.TotalRecord);
        setTotalPage(response.data.TotalPage);
      })
      .catch((error) => {
        toast.error(error.message);
        setError(error.message);
      })
      .finally(() => {
        setIsloading(false);
      });
  }, [router.query]);

  const setParam = (obj) => {
    const { query } = router;
    for (const [key, value] of Object.entries(obj)) {
      query[key] = value;
    }
    if (currentRoutingTypeId == "ProductCategory") query["tip"] = page.id;
    if (currentRoutingTypeId == "ProductDestination") query["bolge"] = page.id;

    if (
      router.query.slug != searchResultSlug &&
      !page.CustomList &&
      !(currentRoutingTypeId == "ProductSearch" && page.id == 554)
    ) {
      query.slug = [searchResultSlug];
      router.replace(
        {
          query: query,
        },
        undefined,
        {
          scroll: true,
        },
      );
    } else {
      query.slug = [page.url];
      router.push(
        {
          query: query,
        },
        undefined,
        {
          scroll: true,
          shallow: true,
        },
      );
    }
  };

  const setPage = (p) => {
    setParam({ s: p });
  };

  const HandleSubmit = (e) => {
    e.preventDefault();
    router.reload();
  };

  useEffect(() => {
    if (data)
      c.listing(
        SqlDate(router.query.start || ""),
        SqlDate(router.query.end || ""),
        router.query.yetiskin || 1 + router.query.cocuk || 0,
        data.map((e) => e.id),
      );
  }, [data]);

  const SqlDate = (d) => {
    let a = d.split("-");
    return a[2] + "." + a[1] + "." + a[0];
  };

  const showBanner = (index) => {
    if (!width) return false;

    if (width > 1280) return index === 8;
    if (width > 640) return index === 3;
    return index === 2;
  };
  return (
    <>
      {/* Back Button */}
      <Banner ssr={ssr} isAppWebView={isAppWebView} />
      {ssr.disableHeader != true && (
        <form onSubmit={HandleSubmit}>
          {ssr.result.ShowTopSearchBar != "0" && (
            <TopSearchBar
              setParam={setParam}
              RoutingTypeId={ssr.RoutingTypeId}
              PageId={ssr.result.id}
            />
          )}
        </form>
      )}

      {ssr.RoutingTypeId == "ShortTerms" && <ShortTerms hideTitle={true} />}

      <div className="bg-brand-gray-7 ">
        <div className="container ">
          {((ssr.RoutingTypeId == "ShortTerms" &&
            ssr.result.ShortTerms == "1" &&
            data) ||
            ssr.RoutingTypeId != "ShortTerms") && (
            <>
              <FilterSummary totalRecord={totalRecord} setParam={setParam} />
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
                {error ? (
                  <div>{error}</div>
                ) : isLoading ? (
                  <div className="col-span-3">
                    <SkeletonView
                      isPhone={isPhone}
                      lengthMobile={6}
                      length={9}
                      flex={false}
                      width="ml:w-[406px]"
                      padding="px-0"
                    />
                  </div>
                ) : (
                  data &&
                  data.map((item, key) => (
                    <React.Fragment key={item.id}>
                      <VillaItem
                        index={key}
                        data={item}
                        shortTerm={ssr.RoutingTypeId == "ShortTerms"}
                        className="w-full bg-white"
                      />
                      {showBanner(key) && (
                        <div className="col-span-1 sm:col-span-2 xl:col-span-3">
                          <KiralaGelBanner
                            src={
                              width && width > 640
                                ? "/images/kiralagel-banner/1350x210.jpeg"
                                : "/images/kiralagel-banner/575x260.png"
                            }
                            listingPage={true}
                            heightClass={width && width > 640 ? "h-52" : "h-64"}
                            deviceType={deviceType}
                          />
                        </div>
                      )}
                    </React.Fragment>
                  ))
                )}
              </div>
              {/* Pagination */}
              <Pagination
                setPage={setPage}
                currentPage={currentPage}
                totalPage={totalPage}
              />
              {/* Pagination */}
            </>
          )}

          {/* Page Content */}
          {page.icerik && <Content content={page.icerik}></Content>}
          {/* Page Content */}
        </div>
      </div>
    </>
  );
};

export default ProductCategory;
